/**
 * 考试作业
 */
import request from "@/utils/request"
import { postForm } from "@/utils/form"

/*
考试列表
*/
export const GetExamLit = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GeteOnlineExamList",
        params
    })
}

// 考生开始答题
export const WriteCacheStartAnswer = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/WriteCacheStartAnswer",
        params
    })
}

/*
首页统计
*/
export const IndexStatic = (params) => {
    return request({
        method: "POST",
        url: "/Api/User/HomeStat",
        params
    })
}

/*
考试提醒
*/
export const IndexExamTip = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetMessageExamTip",
        params
    })
}

// 获取组卷随机考试

export const SetRandomExam = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/SetRandomExam",
        params
    })
}

// 获取 随机组卷的题
export const GetRandomExam = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetRandomExam",
        params
    })
}

// 获取 某个考试的随机试卷
export const GetRandomExamPaperId = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetRandomExamPaperId",
        params
    })
}

// 获取栏目试卷模块
export const GetColumnPaper = (params) => {
    return request({
        method: "POST",
        url: "/Api/Column/GetColumnPaper",
        params
    })
}

// 获取首页栏目试卷模块
export const GetHomeColumnPaper = (params) => {
    return request({
        method: "POST",
        url: "/Api/Column/GetHomeColumnPaper",
        params
    })
}

// 获取考试接口
export const GetExamInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetExamInfo",
        params
    })
}

// 获取考试信息接口
export const GetExamNoteInfo = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/GetExamNoteInfo",
        params
    })
}

// 验证组卷是否有数据
export const VerifyRandomExam = (params) => {
    return request({
        method: "POST",
        url: "/Api/Medical/VerifyRandomExam",
        params
    })
}

// export async function SetRandomExam(params) {
//   return postForm("/Api/Medical/SetRandomExam", params)
// }

//  ************************------------------试卷接口--------------------

// 新建题型

// 扫码考试
export const ScanExam = (examid) => {
    return request({
        method: "POST",
        url: "/Website/Exam/IsExam",
        params: {
            examid
        }
    })
}
